import { render, staticRenderFns } from "./new-direct-request.modal.vue?vue&type=template&id=64b5e636&scoped=true"
import script from "./new-direct-request.modal.vue?vue&type=script&lang=js"
export * from "./new-direct-request.modal.vue?vue&type=script&lang=js"
import style0 from "./new-direct-request.modal.vue?vue&type=style&index=0&id=64b5e636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5e636",
  null
  
)

export default component.exports